<template>
  <training-document-list></training-document-list>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import TrainingDocumentList from "@/components/TrainingDocumentList.vue";

export default defineComponent({
  name: "TrainingDocumentListScreen",
  components: {
    TrainingDocumentList,
  },
});
</script>

<style></style>
